import React, {Component} from 'react';
import {connect} from 'react-redux';

/**
 * Dev Tools container
 */
class DevTools extends Component {

  toggleDisplay() {
    const devToolsElement = document.querySelector('div.nppe2-fc-dev-tools');
    devToolsElement.classList.toggle('open');
  }

  render() {
    const {petInfoReady, feedingGuidelinesGenerateReady, calculateDerReady,
      petName, clinicRecordNumber, mealsPerDay, displayFeedingGuidelines, notes,
      calculateDerData
    } = this.props;
    // If data is pending
    if(!petInfoReady || !feedingGuidelinesGenerateReady || !calculateDerReady ||
      !calculateDerData.secret
    ) return (<div/>);
    // Return dev output
    return (
      <div className='nppe2-fc-dev-tools open'>
        <div className="toggle-dev-tools" onClick={this.toggleDisplay}>
          toggle
        </div>

        <p><strong>Pregnancy factor:</strong> {calculateDerData.devTools.pregnancyFactor}</p>
        <p><strong>Lactation factor:</strong> {calculateDerData.devTools.lactationFactor}</p>
        <p><strong>Sterilised factor:</strong> {calculateDerData.devTools.sterilisedFactor}</p>
        <p><strong>Size factor:</strong> {calculateDerData.devTools.sizeFactor}</p>
        <p><strong>Activity factor:</strong> {calculateDerData.devTools.activityFactor}</p>
        <p><strong>Age factor:</strong> {calculateDerData.devTools.ageFactor}</p>
        <p><strong>Temperature factor:</strong> {calculateDerData.devTools.temperatureFactor}</p>
        <p><strong>illness factor:</strong> {calculateDerData.devTools.illnessFactor}</p>
        <p><strong>Ideal body Weight:</strong> {calculateDerData.devTools.idealBodyWeight}</p>
        <p><strong>Life Stage:</strong> {calculateDerData.devTools.lifeStage}</p>
        <p><strong>Casuistic:</strong> {calculateDerData.devTools.casuistic}</p>
        <p><strong>Body Weight:</strong> {calculateDerData.devTools.bodyWeight}</p>
        <p><strong>WAC:</strong> {calculateDerData.devTools.wac}</p>
        <p><strong>RER:</strong> {calculateDerData.devTools.rer}</p>
        <p><strong>MER:</strong> {calculateDerData.devTools.mer}</p>
        <p><strong>Used Formula:</strong> {calculateDerData.devTools.usedFormula}</p>
        <p><strong>DER:</strong> {calculateDerData.der}</p>
        <hr/>
        <p><strong>Pet Name:</strong> {petName}</p>
        <p><strong>Clinic Record Number:</strong> {clinicRecordNumber}</p>
        <p><strong>Meals per day:</strong> {mealsPerDay}</p>
        <p><strong>Notes:</strong> {notes}</p>
        <hr/>
        <p><strong>Display feeding guidelines:</strong> {displayFeedingGuidelines ? "Yes" : "No"}</p>

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    petName: state.petInfoReducer.petName,
    clinicRecordNumber: state.petInfoReducer.clinicRecordNumber,
    mealsPerDay: state.petInfoReducer.mealsPerDay,
    displayFeedingGuidelines: state.feedingGuidelinesGenerateReducer.displayFeedingGuidelines,
    notes: state.feedingGuidelinesGenerateReducer.notes,
    calculateDerData: state.calculateDerReducer.data,
    // Ready
    petInfoReady: state.petInfoReducer.ready,
    feedingGuidelinesGenerateReady: state.feedingGuidelinesGenerateReducer.ready,
    calculateDerReady: state.calculateDerReducer.ready,
  }
};


export default connect(mapStateToProps)(DevTools);
